import React from 'react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import translations from '../../languages/i18n';

export default function AllDataTable({ data, labels }) {
  return (
    <TableContainer component={Paper} style={{maxWidth: 1100}} overflowx='auto'>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{fontWeight: 'bold'}}>{translations['_program']}</TableCell>
            {
              data.map((monthData) => {
                return (<TableCell style={{fontWeight: 'bold', textAlign: 'center'}} key={`X_${monthData.date}`}>{monthData.date}</TableCell>)
              })
            }                           
          </TableRow>            
        </TableHead>
        <TableBody>
          {
            labels.map((label) => {
              return (
                <TableRow hover key={`Y1_${label}`}>
                  <TableCell key={`Y2_${label}`}>{label}</TableCell>
                    {
                      data.map((monthData) => {
                        return (<TableCell key={`Y3_${monthData.date}`}>{monthData[label] || 0}</TableCell>)
                      })
                    }
                </TableRow>
              )
            })
          }
          <TableRow>
            <TableCell style={{fontWeight: 'bold'}}>{translations['_total']}</TableCell>      
            {
              data.map((monthData) => {
                let totalMonth = 0;
                Object.entries(monthData).map(([key, value]) => {
                  if (key !== 'date') {
                    totalMonth = totalMonth + value;
                  }
                })
                  return (
                    <TableCell key={`Z_${monthData.date}`}>{totalMonth}</TableCell>
                  )                  
              })    
            }
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>      
  )
}

// Indica i controla els props que se han de passar al component
AllDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
};
